import { Component, Injector, Input, ChangeDetectorRef } from "@angular/core";
import { finalize } from "rxjs/operators";
import { appModuleAnimation } from "@shared/animations/routerTransition";
import { AppComponentBase } from "@shared/app-component-base";
import {
  CompetenciaDto,
  CompetenciaServiceProxy,
  CreateAvaliacaoRequisitoVagaDto
} from "@shared/service-proxies/service-proxies";
import { Observable } from "rxjs";
import { ModalNovaPerguntaComponent } from './modal-nova-pergunta/modal-nova-pergunta.component';
import { NgbModal } from "@node_modules/@ng-bootstrap/ng-bootstrap";
import { ModalPreVisualizacaoComponent } from "./modal-pre-visualizacao/modal-pre-visualizacao.component";
import { Router } from "@node_modules/@angular/router";

@Component({
  selector: "form-sobre-candidato",
  templateUrl: "./form-sobre-candidato.component.html",
  styleUrls: ["./form-sobre-candidato.component.scss"],
  animations: [appModuleAnimation()],
})

export class FormSobreCandidatoComponent extends AppComponentBase {

  @Input() vaga;
  @Input() view = false;
  @Input() empresaEspecial = false;

  saving = false;
  nomeCompetencia: string = '';
  competencias: CompetenciaDto[] = [];
  @Input() competenciasSelect: CompetenciaDto[] = [];
  competencia: CompetenciaDto;
  indiceEdicao: number | null = null;
  competenciaEditavel: CompetenciaDto = new CompetenciaDto();
  expandedIndex: { [key: number]: boolean } = {};


  constructor(
    injector: Injector,
    private _competenciaService: CompetenciaServiceProxy,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    private _route: Router
  ) {
    super(injector);
  }

  ngOnInit() {
    this.loadCompetencias();
  }


  private load<T>(serviceCall: () => Observable<T>, setter: (data: T) => void): void {
    abp.ui.setBusy();
    serviceCall()
      .pipe(finalize(() => abp.ui.clearBusy()))
      .subscribe(setter);
  }

  loadCompetencias(): void {
    this.load<CompetenciaDto[]>(() => this._competenciaService.getAll(), data => this.competencias = data);
    if (this.vaga.competencias && this.vaga.competencias.length > 0) {
      this.competenciasSelect = this.vaga.competencias
    }
  }

  removerCompetencia(competencia: CompetenciaDto) {
    const index = this.competenciasSelect.indexOf(competencia);
    if (index !== -1) {
      this.competenciasSelect.splice(index, 1);
    }
  }
  iconeAcao(i: number): string {
    return i === this.indiceEdicao ? "fa-check" : "fa-pencil-alt";
  }

  iconeAcaoTitulo(i: number): string {
    return i === this.indiceEdicao ? "Save" : "Edit";
  }

  toggleEdicao(indice: number, competencia: CompetenciaDto) {
    if (this.indiceEdicao !== null && this.indiceEdicao === indice) {
      this.cancelarEdicao();
    } else {
      this.iniciarEdicao(indice, competencia);
    }
  }

  verificaRota(): boolean{
    return this._route.url.includes('resumo');
  }

  iniciarEdicao(indice: number, competencia: CompetenciaDto) {
    this.indiceEdicao = indice;
    this.competenciaEditavel = competencia;
  }

  salvarEdicao(indice: number) {
    if (this.indiceEdicao !== null) {
      this.competencias[indice] = this.competenciaEditavel;
      this.cancelarEdicao();
    }
  }

  cancelarEdicao() {
    this.indiceEdicao = null;
    this.competenciaEditavel = new CompetenciaDto();
  }

  onCompetenciaDigitada(competenciaDigitada: string) {
    this.nomeCompetencia = competenciaDigitada;
  }

  adicionarCompetencia() {
    if ((this.competencia) && (!!this.nomeCompetencia) && (!(this.competenciasSelect.find((comp) => this.competencia.nome == comp.nome))) && (this.competencia.nome == this.nomeCompetencia)) {
      this.competenciasSelect.push(this.competencia);
      this.competencia = new CompetenciaDto();
      this.nomeCompetencia = undefined;
    }
    else if ((this.nomeCompetencia) && (this.nomeCompetencia)) {
      var comp = new CompetenciaDto();
      comp.nome = this.nomeCompetencia;
      this.competenciasSelect.push(comp);
      this.nomeCompetencia = undefined;
      this.competencia = new CompetenciaDto();
    }
    this.vaga.competencias =
      this.competenciasSelect.length > 0 ? this.competenciasSelect : [];
  }

  adicionarAvaliacaoRequisito() {
    if (this.vaga?.avaliacoesRequisitosVaga?.length >= 3) {
      abp.notify.error("Já existe o limite de 3 perguntas. Edite ou remova uma pergunta existente.");
      return;
    }

    const modalRef = this.modalService.open(ModalNovaPerguntaComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true
    });

    modalRef.componentInstance.tituloSave = "Adicionar Pergunta";

    modalRef.componentInstance.perguntaCriada.subscribe((novaPergunta: CreateAvaliacaoRequisitoVagaDto) => {
      if (!this.vaga) {
        this.vaga = { avaliacoesRequisitosVaga: [] };
      } else if (!this.vaga.avaliacoesRequisitosVaga) {
        this.vaga.avaliacoesRequisitosVaga = [];
      }

      this.vaga.avaliacoesRequisitosVaga.push(novaPergunta);
    });
  }


  editarPergunta(index: number, pergunta: CreateAvaliacaoRequisitoVagaDto) {
    const modalRef = this.modalService.open(ModalNovaPerguntaComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true
    });

    modalRef.componentInstance.pergunta = { ...pergunta };
    modalRef.componentInstance.tituloSave = "Salvar Pergunta";

    modalRef.componentInstance.perguntaCriada.subscribe((perguntaEditada: CreateAvaliacaoRequisitoVagaDto) => {
      this.vaga.avaliacoesRequisitosVaga[index] = Object.assign(new CreateAvaliacaoRequisitoVagaDto(), perguntaEditada);
    });
  }

  abrirPreVisualizacao(index: number, pergunta: CreateAvaliacaoRequisitoVagaDto) {
    const modalRef = this.modalService.open(ModalPreVisualizacaoComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true
    });

    modalRef.componentInstance.perguntas = this.vaga.avaliacoesRequisitosVaga;
  }

  removerPergunta(index: number) {
    this.vaga.avaliacoesRequisitosVaga.splice(index, 1);
    this.cdr.markForCheck();
  }

  toggleExpand(index: number) {
    this.expandedIndex[index] = !this.expandedIndex[index];
  }
}
